import { httpAdminReport } from "../helper/http-common";

class AdminJewelryReportService {
  GetVendorDropdownList(inputData) {
    return httpAdminReport.post(
      "/Admin_JewelryReport/Admin_VendorDetails",
      inputData
    );
  }
  GetRetailerDropdownList(inputData) {
    return httpAdminReport.post(
      "/Admin_JewelryReport/Admin_RetailerDetails",
      inputData
    );
  }
  ChangeRetailerList(inputData) {
    return httpAdminReport.post(
      "/Admin_JewelryReport/Bind_RetailerDetails",
      inputData
    );
  }
  ChangeVendorList(inputData) {
    return httpAdminReport.post(
      "/Admin_JewelryReport/Bind_VendorDetails",
      inputData
    );
  }
  GetClicksBasedOnCategory(inputData) {
    return httpAdminReport.post(
      "/Admin_JewelryReport/Admin_JewelryCategoryChartColunmData",
      inputData
    );
  }
  GetClicksCount(inputData) {
    return httpAdminReport.post(
      "/Admin_JewelryReport/AdminJewelryReportTableChart_Count",
      inputData
    );
  }
  GetClicksBasedOnRetailer(inputData) {
    return httpAdminReport.post(
      "/Admin_JewelryReport/Admin_JewelryTopRetailerChartColunm",
      inputData
    );
  }
  GetClicksBasedOnPrice(inputData) {
    return httpAdminReport.post(
      "/Admin_JewelryReport/Admin_JewelryPriceChartColunmData",
      inputData
    );
  }
  GetClicksBasedOnVendor(inputData) {
    return httpAdminReport.post(
      "/Admin_JewelryReport/Admin_JewelryTopVendorRetailerChartColunm",
      inputData
    );
  }
  GetForDealer(inputData) {
    return httpAdminReport.post(
      "/Admin_JewelryReport/CheckDealermembers",
      inputData
    );
  }
  GetTableChartData(inputData) {
    return httpAdminReport.post(
      "/Admin_JewelryReport/Admin_JewelryReportForTableChart",
      inputData
    );
  }
  GetMetalTypeData(inputData) {
    return httpAdminReport.post(
      "/Admin_JewelryReport/Admin_JewelryMetaltypeChartColunmData",
      inputData
    );
  }

  JewelryReportForTableChartCSVDownload(inputData) {
    return httpAdminReport.post(
      "/Admin_JewelryReport/Admin_JewelryReportForTableChart_CSV_Download",
      inputData, {
      responseType: "arraybuffer",
    }
    );
  }

  ExportActivityPdf(inputData) {
    return httpAdminReport.post(
      "/Admin_JewelryReport/ExportActivityPdf",
      inputData,
      { responseType: "arraybuffer" }
    );
  }

  // Single-metric "Download PDF" for the Global Jewelry drill-down pages
  // (Category, Metal Type, Price).
  ExportMetricPdf(inputData) {
    return httpAdminReport.post(
      "/Admin_JewelryReport/ExportMetricPdf",
      inputData,
      { responseType: "arraybuffer" }
    );
  }

  JewelryReportForTableChartPDFDownload(inputData) {
    return httpAdminReport.post(
      "/Admin_JewelryReport/Admin_JewelryReportForTableChart_PDF_Download",
      inputData,
      {
        responseType: "arraybuffer",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/pdf",
        },
      }
    );
  }
}

export default new AdminJewelryReportService();
